import React from 'react';
import DocumentRequirementList from './DocumentRequirementList';
import { splitByPhase } from '../../../../hooks/useRequiredDocuments';

const EMPTY_DOC_TYPE_MAP = {};

const PersonDocumentsSlot = ({
    ownerId,
    displayName,
    documents = [],
    recordId,
    asLabel,
    onDocumentsChanged,
    docTypeMap = EMPTY_DOC_TYPE_MAP,
}) => {
    if (!ownerId) return null;
    const mine = documents.filter((row) => row?.ownerId === ownerId);
    if (!mine.length) return null;
    const phases = splitByPhase(mine);

    return (
        <div className="docfirst__person-docs">
            <div className="docfirst__person-docs-head">
                {displayName ? `Documents for ${displayName}` : 'Documents'}
            </div>
            <DocumentRequirementList
                documents={phases.start}
                recordId={recordId}
                asLabel={asLabel}
                docTypeMap={docTypeMap}
                onDocumentsChanged={onDocumentsChanged}
            />
            {phases.final.length > 0 && (
                <>
                    <div className="docfirst__group-subhead">Needed once the people are added</div>
                    <DocumentRequirementList
                        documents={phases.final}
                        recordId={recordId}
                        asLabel={asLabel}
                        docTypeMap={docTypeMap}
                        onDocumentsChanged={onDocumentsChanged}
                    />
                </>
            )}
            <div className="docfirst__person-docs-note">
                Each document is uploaded once here and saved to the application.
            </div>
        </div>
    );
};

export default PersonDocumentsSlot;

